export const uniq = arr => [...new Set(arr)];
